<div class="page">
    <h2 class="mb-3">Aplikacija nije optimizovana za ovu rezoluciju ekrana.</h2>
    <h4 class="text-muted font-weight-normal mb-7">Molimo Vas da je
        otvorite na veċem ekranu.</h4>
</div>